/**
 * Automate api server endpoint.
 * @type {string}
 */
export const AUTOMATE_SERVER_URL: string =
  "https://llamalab.com/automate/cloud/message"

/**
 * IPData api server base url.
 * @type {string}
 */
export const IPDATA_SERVER_URL: string = "https://api.ipdata.co"
